import '../chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.SortingActionsView extends Backbone.View
  template: JST['backbone/templates/monitoring/charts/sorting_actions']

  initialize: ->
    @actualSortingCriteria = 'sort_default'

  render: ->
    @$el.html @template({
      actualSortingCriteria: @getI18nSelectedSortingCriteria()
    })
    @

  getI18nSelectedSortingCriteria:() ->
    I18n.t('monitoring.dashboard.charts.sort_bars.' + @actualSortingCriteria)

  changeSelectedSorting: (newSortingCriteria) ->
    @actualSortingCriteria = newSortingCriteria
